<template>
  <div class="doc-label-view">
    <div class="content-box-header">{{ `关联文档（${value.length}/10）` }}</div>
    <div class="doc-box">
      <ul class="doc-ul">
        <li v-for="row in value" :key="row.id" class="doc-li">
          <div class="doc-item-content">
            <img :src="mapDocType(row)" alt="" class="doc_type_icon" />
            <span class="">{{ row.name }}</span>
            <span class="doc-size">{{ bytesToSize(row.size) }}</span>
          </div>
          <el-button type="text" @click="deleteDoc(row)">删除</el-button>
        </li>
      </ul>
      <div>
        <el-button type="text" @click="addDoc">添加关联文档</el-button>
      </div>
    </div>

    <!-- 添加关联文档弹窗 -->
    <DocDialog
      v-if="docDialogVisible"
      :label-doc="value"
      :dialog-visible="docDialogVisible"
      @clickConfirm="chooseDoc"
      @clickCancel="docDialogVisible = false"
    ></DocDialog>
  </div>
</template>

<script>
import DocDialog from './docDialog';
import { bytesToSize } from '@/utils/util';
import { IMG_SRC } from '@/utils/constant';
const { docTypeImg } = IMG_SRC;

export default {
  name: 'DocLabel',
  components: {
    DocDialog,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      bytesToSize,
      docDialogVisible: false, // 添加关联文档
      labelDocList: this.value,
    };
  },
  watch: {
    value(val) {
      this.labelDocList = val;
    },
  },
  created() {},
  methods: {
    mapDocType(row) {
      return docTypeImg[row.documentType] || docTypeImg.default;
    },
    // 添加关联文档
    addDoc() {
      this.docDialogVisible = true;
    },
    chooseDoc(docList) {
      console.log(666, docList);
      this.labelDocList = docList;
      this.docDialogVisible = false;
      console.log(JSON.stringify(this.labelDocList));
      this.$emit('input', this.labelDocList);
    },
    deleteDoc(row) {
      const index = this.labelDocList.findIndex((item) => item.id === row.id);
      console.log({ index });
      if (index !== -1) {
        this.labelDocList.splice(index, 1);
        this.$emit('input', this.labelDocList);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.doc-label-view {
  .content-box-header {
    color: #303133;
    font-weight: bold;
    height: 22px;
    line-height: 22px;
    margin-bottom: 16px;
    margin-top: 20px;
  }
  .doc-box {
    .doc-ul {
      .doc-li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .doc-item-content {
          color: #313233;
          .doc-size {
            padding-left: 20px;
          }
          .doc_type_icon {
            width: 24px;
            height: 24px;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
    }
  }
}
</style>
